import baseApi from './RootBaseApi';
import type { ApiResponse } from '@/types/api.types';
import type {
  SubscriptionTrialConfig,
  SubscriptionTrialConfigUpdatePayload,
} from '@/types/subscription-trial-config.types';

export const SubscriptionTrialConfigService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionTrialConfig: builder.query<
      ApiResponse<SubscriptionTrialConfig>,
      void
    >({
      query: () => ({
        url: '/system-config/trial',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),

    updateSubscriptionTrialConfig: builder.mutation<
      ApiResponse<SubscriptionTrialConfig>,
      SubscriptionTrialConfigUpdatePayload
    >({
      query: (payload) => ({
        url: '/system-config/trial',
        method: 'PUT',
        data: payload,
      }),
    }),
  }),
});

export const {
  useGetSubscriptionTrialConfigQuery,
  useUpdateSubscriptionTrialConfigMutation,
} = SubscriptionTrialConfigService;
